<ion-grid class="course-schedule {{class}}" *transloco="let t; prefix: 'courseScheduleComp'">
    <ion-row class="ion-align-items-center title">
        <ion-col size="12">
<!--            {{ group.title | transloco}}-->
            {{ group.title}}
        </ion-col>
    </ion-row>

    <div class="content">
        <ion-row class="ion-hide-sm-up m-wrapper" *ngIf="group.typeCourse != GROUP_TYPE_CAMP && isSmallScreen()">
            <ion-col size="12">

                <app-group-info
                    [group]="group"
                    [class]="'grey-bg'"
                    [title]="''  "
                    [groupTitle]="'studyProgressBarComp.aboutCourse'|transloco "
                ></app-group-info>
            </ion-col>
        </ion-row>

        <div *ngIf="group.typeCourse != GROUP_TYPE_CAMP">
            <app-group-statistic *ngIf="group.time !=='isFuture'"
                                 [attendance]="group.attendance > 0 ? group.attendance+'%' :'-'"
                                 [missedLessons]="group.missedLessons"
                                 [totalLessons]="group.totalLessons"
                                 [totalSS]="group.studyProgress.totalSS"
                                 [completedSS]="group.studyProgress.completedSS ? group.studyProgress.completedSS : 0"
                                 [selfStudy]="group.studyProgress.avgProgress ? group.studyProgress.avgProgress+'%' : '_'"
                                 [maxMark]="group.studyProgress.testMaxMark"
                                 [passedExamsMarkAvg]="group.studyProgress.testAverage"
                                 [totalExams]="group.studyProgress.exams?.totalExams"
                                 [passedExams]="group.studyProgress.passedTestAmount"
                                 [finalExam]="group.studyProgress.finalExam?.score"
            ></app-group-statistic>
        </div>


        <app-group-statistic *ngIf="group.time ==='isFuture'"
        ></app-group-statistic>

        <ion-row class="progress-bar">
            <ion-col>
                <app-study-progress-bar
                    [duration]="group.duration"
                    [isTypeCamp]="group.typeCourse === GROUP_TYPE_CAMP"
                    [currentLesson]="group.time ==='isFuture'? 0 :group.currentLesson"
                    [totalLessons]="group.totalLessons"
                ></app-study-progress-bar>
            </ion-col>
        </ion-row>

        <ion-row class="lessons-wrapper" *ngIf="group.educationalMaterialId != 0">

            <ion-col>
                <div class="ion-padding-bottom"> {{ t('lessons') }}</div>

                <ion-row class="lessons-row">
                    <div class="lesson-square" *ngFor="let lesson of lessons;"
                         [ngClass]="{
             'visit': lesson.passed,
             'absence': lesson.absence,
             'test': lesson.test && lesson.passed,
             'basic': !lesson.passed
           }">
                        <div class="lesson-wrapper">

                            <div *ngIf="!lesson.passed && lesson.date">
                                {{ lesson.date.substring(0, 5) }}
                            </div>

                        </div>


                        <div class="popover d-none">
                            <ion-grid class="popover-wrapper ion-no-padding">

                                <ion-row class="ion-justify-content-between popover-title">
                                    <ion-col size="auto">{{ t('lesson') }} {{ lesson.number }}</ion-col>
                                    <ion-col size="auto">{{ lesson.date }}</ion-col>
                                </ion-row>
                                <ion-row *ngIf="lesson.title">{{ lesson.title }} : {{ lesson.progress }}%</ion-row>


                                <ion-row *ngIf="lesson.test">{{ t('test') }}: {{ lesson.testScore }}/50</ion-row>
                            </ion-grid>
                        </div>
                    </div>

                </ion-row>

                <button *ngIf="group.time !=='isPast'" type="button" class="btn"
                        (click)="goToStudyProgress(group.id)"> {{ t('progressBtn') }}
                </button>

                <div class="btn-wrapper" *ngIf="group.time ==='isPast'">

                    <button  type="button" class="btn"
                            (click)="goToStudyProgress(group.id)"> {{ t('progressBtn') }}
                    </button>

                    <button *ngIf="group.certificate" type="button" class="btn"
                            (click)="openCertificate(group.certificate)">{{ t('certificatesBtn') }}
                    </button>

                </div>


            </ion-col>
        </ion-row>

    </div>

</ion-grid>
